<template>
    <rkm-modal
        extraLarge
        ref="Modal"
        title="Atribuição de cota do exame para unidade solicitante"
    >
        <Form
            :data="data"
            :item="item"
            :cotalaboratorio="cotalaboratorio"
            :indexItem="index"
            :indexExame="indexExame"
            @save="handleExit"
            ref="Form"
        />

         <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import Form from './Form'

// Mixins.
import { repository, object, data } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    components: { Form },
    data: () => ({
        index: null,
        item: null
    }),
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(index, item) {

            this.index = index
            this.item = item

            if (item.unidadeSolicitanteAlterada) {
                this.$refs.Modal.show()
            } else {

                this.getCotaLaboratorioExameUnidade(item)
            }

            this.$refs.Modal.show()
        },
        getCotaLaboratorioExameUnidade(item) {

            this.setLoading()

            this.repositories.parametrizacao.getCotaLaboratorioExameUnidade({
                cota_exame_id: item.id,
                exame_id: item.exameId,
                cota_tipo_id: this.cotalaboratorio.cotaTipoId,
                inicio: moment(this.cotalaboratorio.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                fim: moment(this.cotalaboratorio.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                infraestrutura_id: this.cotalaboratorio.infraestruturaId,
            })
                .then(response => {

                    this.item.unidadeSolicitante = response.data

                    item.unidadeSolicitante = response.data
                    item.unidadeSolicitanteAlterada = true

                    this.$refs.Modal.show()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit(data) {

            this.$emit('save', data)
        },
        handleSave() {

            this.$refs.Form.save()
        },
    },
    mixins: [ repository, object, data ],
    props: {
        data: { type: Object, required: true },
        cotalaboratorio: { type: Object, required: true },
        indexExame: { type: [Number, String], required: true },
    }
}
</script>